import "static/css/app.css";

import { RipeCommonsMainPlugin } from "ripe-commons-pluginus";

import { components } from "../../../vue";

export class RipeRetailMainPlugin extends RipeCommonsMainPlugin {
    _getExtraComponents() {
        return components;
    }

    async _initVueApp(element) {
        const app = await super._initVueApp(element);

        // listens for the design selected event and changes the current
        // model to it (imperative/action event)
        app.$bus.bind("design_selected", async config => {
            // if there is no description then force its removal
            // from the config object and then sets the "new" model
            config.description = config.description || null;
            await this.setModel(config);
        });

        return app;
    }

    _getStoreDef() {
        const base = super._getStoreDef();
        return {
            ...base,
            state: Object.assign({}, base.state, {
                account: "",
                customerId: "",
                customerIdInput: false,
                orderNumber: null,
                store: "",
                storeBrand: ""
            }),
            mutations: Object.assign({}, base.mutations, {
                account(state, account) {
                    state.account = account;
                },
                customerId(state, customerId) {
                    state.customerId = customerId;
                },
                customerIdInput(state, customerIdInput) {
                    state.customerIdInput = customerIdInput;
                },
                store(state, store) {
                    state.store = store;
                },
                storeBrand(state, storeBrand) {
                    state.storeBrand = storeBrand;
                }
            }),
            getters: base.getters
        };
    }

    async _loadOptions() {
        // creates the initial options dictionary from the DOM
        const optionsS = this.appElement.getAttribute("data-options");
        const storeBrand = this.appElement.getAttribute("data-brand");
        const storeName = this.appElement.getAttribute("data-store");
        const account = this.appElement.getAttribute("data-account");
        const options = JSON.parse(optionsS);
        options.store = storeName;
        options.account = account;
        options.url = options.api_url;

        // if there are parts define for the initial model
        // then parses them and creates a parts dictionary
        if (options.product && options.product.parts) {
            const parts = options.product.parts;
            const partsM = parts.length ? {} : null;
            parts.forEach(part => {
                const [name, material, color] = part.split(":");
                if (!name) {
                    return;
                }
                partsM[name] = {
                    material: material,
                    color: color
                };
            });
            options.product.parts = partsM;
            options.model = options.product.model;
            options.brand = options.product.brand;
            options.product_id = options.product.product_id;
        }

        // sets the options and the app locale
        this.options = options;
        await this.localePlugin.setLocale(this.options.locale);

        // initializes the app state with the provided options
        this.store.commit("storeBrand", storeBrand);
        this.store.commit("store", this.options.store);
        this.store.commit("account", this.options.account);
        this.store.commit("customerIdInput", this.options.customer_id);
        this.store.commit("ripeUrl", this.options.api_url);
        this.store.commit("currency", this.options.currency);
        this.store.commit("country", this.options.country);
        this.store.commit("locale", this.options.locale);
        this.store.commit("flag", this.options.flag);
    }
}

RipeRetailMainPlugin.register();
